/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
  Divider,
  Label,
  Popup,
  Menu,
  Checkbox,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import { UnitPackagePricingEdit } from './';
import { SortableContainer, SortableDragHandle } from '../Sortable';
import AppForm from '../AppForm';
import CurrencySymbol from '../CurrencySymbol';
import EditableBox from '../EditableBox';
import LoanAmount from '../LoanAmount';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import DeleteConfirm from '../../containers/modals/DeleteConfirm';
import { PROJECT_UNIT_PACKAGE_PRICING_DEFAULT } from '../../structs/package_pricing';
import config from '../../../config';
import { getItem } from '../../utils/storage';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import QuotationPackageSelection from '../QuotationPackageSelection/QuotationPackageSelection';

export const ProjectUnitPackagePricingView = ({
  unitPackagePricings,
  spaValue,
  projectCurrencies = [],
  isPreviewing,
  calculatePackagePricing,
  sellingPriceCustomName,
  t,
}) => {
  const items = [{
    listPrice: spaValue,
    spaPrice: spaValue,
    totalPrice: spaValue,
    projectPackagePricing: {
      name: sellingPriceCustomName || t('Selling Price'),
      description: t('Unit Base Selling Price'),
    },
    isSPAValue: true,
  }];

  unitPackagePricings.sort((a, b) => a.orderPriority - b.orderPriority).forEach((d) => {
    let calculations = [];

    if (calculatePackagePricing && calculatePackagePricing.some(data => data.id === d.id)) {
      const pupp = calculatePackagePricing.find(data => data.id === d.id);
      if (!pupp.isCustomPrice && pupp.projectPackagePricing.packagePricingCalculations) {
        calculations = [...pupp.projectPackagePricing.packagePricingCalculations];
      }
    }

    const newItem = {
      customDescription: d.customDescription,
      customName: d.customName,
      isCustomPrice: d.isCustomPrice,
      isSPAValue: false,
      projectPackagePricingID: d.projectPackagePricingID,
      listPrice: d.listPrice,
      spaPrice: d.spaPrice,
      totalPrice: d.totalPrice,
      packagePricingCalculations: calculations,
    };

    if (d.projectPackagePricing) {
      let iDesc = d.projectPackagePricing.description;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map((desc, idx) => <span key={idx}>{desc}<br /></span>);
      }
      newItem.projectPackagePricing = {
        name: d.projectPackagePricing.name,
        description: iDesc,
      };
    }
    items.push(newItem);
  });
  const renderFormulaChangeClass = (type) => {
    if (type.includes('deduct')) {
      return 'text_deduct';
    }
    if (type.includes('add')) {
      return 'text_add';
    }
    return '';
  };
  const renderFormulaChangePrefix = (type) => {
    if (type.includes('deduct')) {
      return <Icon color="red" size="small" name="minus" />;
    }
    if (type.includes('add')) {
      return <Icon color="green" size="small" name="plus" />;
    }
    return '';
  };
  const customFormulaPrefix = (unitSpaValue, packageTotalPrice) => {
    if (unitSpaValue < packageTotalPrice) {
      return 'custom_formula_add';
    } else if (unitSpaValue > packageTotalPrice) {
      return 'custom_formula_deduct';
    }
    return '';
  };
  const renderApplyToBookingRemarks = (title, applyToBooking) => (
    <span>
      {title}
      <span className="packagePricingApplyToBookingFlag" style={{ color: applyToBooking ? 'green' : 'red' }}>
        {t(`Formula item will${!applyToBooking ? ' not' : ''} be applied onto the initial booking`)}
      </span>
    </span>
  );
  return (
    <Grid className="projectUnitPackagePricingView projectUnitPreview" columns={2}>
      {
        isPreviewing ?
          items.map((data, idx) => {
            if (data.isCustomPrice) {
              // render section for base selling price
              return (
                <Grid container key={idx}>
                  <Grid.Row>
                    <Grid.Column width={8} textAlign="left">
                      <h3>
                        {data.customName || ''}
                        <Label size="small" pointing="left" style={{ marginLeft: '1em' }}>{t('Custom')}</Label>
                      </h3>
                      <small>
                        {data.customDescription || ''}
                      </small>
                    </Grid.Column>
                    <Grid.Column width={8} textAlign="right">
                      <h3>
                        <LoanAmount
                          projectCurrencies={projectCurrencies}
                          format="0,000,000.00"
                          amount={data.totalPrice}
                          prefix={<CurrencySymbol />}
                          precise={false}
                        />
                      </h3>
                    </Grid.Column>
                  </Grid.Row>
                  <Divider />
                </Grid>
              );
            }

            const listCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(ppc => ppc.category === 'list_price') : [];
            const spaCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(ppc => ppc.category === 'spa_price') : [];

            return (
              <Grid container key={idx}>
                <Grid.Row columns={16}>
                  <Grid.Column width={8} textAlign="left">
                    <h3>
                      {
                        data.projectPackagePricingID !== '' ?
                          (data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '') :
                          ''
                    }
                    </h3>
                    <small>
                      {
                        data.projectPackagePricingID !== '' ?
                          (data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '') :
                        ''
                      }
                    </small>
                  </Grid.Column>
                  <Grid.Column width={8} textAlign="right">
                    <h3>
                      <LoanAmount
                        projectCurrencies={projectCurrencies}
                        format="0,000,000.00"
                        amount={data.totalPrice}
                        prefix={<CurrencySymbol />}
                      />
                    </h3>
                  </Grid.Column>
                </Grid.Row>
                {
                  !data.isSPAValue && (
                    <Grid.Row columns={16}>
                      <Grid.Column textAlign="left" width={8}><h4>{t('Unit Base Selling Price')}</h4></Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <h4>
                          <LoanAmount
                            projectCurrencies={projectCurrencies}
                            format="0,000,000.00"
                            amount={data.listPrice}
                            prefix={<CurrencySymbol />}
                            precise={false}
                          />
                        </h4>
                      </Grid.Column>
                    </Grid.Row>
                  )
                }
                {
                  listCalculations.map((ppc, key) => {
                    const customFormulaType = customFormulaPrefix(spaValue, data.totalPrice);
                    const customFormulaCalculationType = ppc.projectPackagePricingItem.calculationType === 'custom_formula'
                      ? customFormulaType
                      : ppc.projectPackagePricingItem.calculationType;
                    return (
                      <Grid.Row columns={16} key={key}>
                        {
                          ppc.isSubTotal ? (
                            <Grid.Column textAlign="left" width={11}><h5>{t('Sub Total')}</h5></Grid.Column>
                          ) : (
                            <Grid.Column textAlign="left" width={11}>
                              <h5>
                                {
                                  ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name
                                    ? renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking)
                                    : ''
                                }
                              </h5>
                              <small>
                                {
                                  ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description
                                    ? ppc.projectPackagePricingItem.description
                                    : ''
                                }
                              </small>
                            </Grid.Column>
                          )
                        }
                        <Grid.Column textAlign="right" width={5}>
                          <LoanAmount
                            projectCurrencies={projectCurrencies}
                            format="0,000,000.00"
                            amount={ppc.newValue}
                            prefix={<CurrencySymbol />}
                            precise={false}
                          />
                          <small>
                            {
                              !ppc.isSubTotal && (
                                <div>
                                  <small>
                                    {renderFormulaChangePrefix(customFormulaCalculationType)}
                                  </small>
                                  <span
                                    className={`div_inline_block ${renderFormulaChangeClass(customFormulaCalculationType)}`}
                                  >
                                    <LoanAmount
                                      projectCurrencies={projectCurrencies}
                                      format="0,000,000.00"
                                      amount={ppc.valueChange}
                                      prefix={<CurrencySymbol />}
                                      precise={false}
                                    />
                                  </span>
                                </div>
                              )
                            }
                          </small>
                        </Grid.Column>
                      </Grid.Row>
                    );
                  })
                }
                {
                  !data.isSPAValue && (
                    <Grid.Row columns={16}>
                      <Grid.Column textAlign="left" width={8}><h4>{t('Total Selling Price SPA')}</h4></Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <h4>
                          <LoanAmount
                            projectCurrencies={projectCurrencies}
                            format="0,000,000.00"
                            amount={data.spaPrice}
                            prefix={<CurrencySymbol />}
                            precise={false}
                          />
                        </h4>
                      </Grid.Column>
                    </Grid.Row>
                  )
                }
                {
                  spaCalculations.map((ppc, key) => {
                    const customFormulaType = customFormulaPrefix(spaValue, data.totalPrice);
                    const customFormulaCalculationType = ppc.projectPackagePricingItem.calculationType === 'custom_formula'
                      ? customFormulaType
                      : ppc.projectPackagePricingItem.calculationType;
                    return (
                      <Grid.Row columns={16} key={key}>
                        {
                          ppc.isSubTotal ? (
                            <Grid.Column textAlign="left" width={11}><h5>{t('Sub Total')}</h5></Grid.Column>
                          ) : (
                            <Grid.Column textAlign="left" width={11}>
                              <h5>
                                {
                                  ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name
                                    ? renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking)
                                    : ''
                                }
                              </h5>
                              <small>
                                {
                                  ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description
                                    ? ppc.projectPackagePricingItem.description
                                    : ''
                                }
                              </small>
                            </Grid.Column>
                          )
                        }
                        <Grid.Column textAlign="right" width={5}>
                          <LoanAmount
                            projectCurrencies={projectCurrencies}
                            format="0,000,000.00"
                            amount={ppc.newValue}
                            prefix={<CurrencySymbol />}
                            precise={false}
                          />
                          <small>
                            {
                              !ppc.isSubTotal && (
                                <div>
                                  <small>
                                    {renderFormulaChangePrefix(customFormulaCalculationType)}
                                  </small>
                                  <span
                                    className={`div_inline_block ${renderFormulaChangeClass(customFormulaCalculationType)}`}
                                  >
                                    <LoanAmount
                                      projectCurrencies={projectCurrencies}
                                      format="0,000,000.00"
                                      amount={ppc.valueChange}
                                      prefix={<CurrencySymbol />}
                                      precise={false}
                                    />
                                  </span>
                                </div>
                              )
                            }
                          </small>
                        </Grid.Column>
                      </Grid.Row>
                    );
                  })
                }
                <Divider />
              </Grid>
            );
          })
        :
        // when preview button is not clicked only show packages with pricing
        items.map((data, idx) => (
          <Grid container key={idx} className="singlePPItemRow">
            <Grid.Row>
              <Grid.Column width={8} verticalAlign="middle" textAlign="right">
                <Header as="h4" className={data.isSPAValue ? 'spaValue' : ''}>
                  {data.projectPackagePricingID !== '' ?
                  (data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '') :
                  (data.customName || '')
                }
                  <Header.Subheader>
                    {data.projectPackagePricingID !== '' ?
                    (data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '') :
                    (data.customDescription || '')
                  }
                  </Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width={8} verticalAlign="middle">
                <h3 className={data.isSPAValue ? 'spaValue' : ''}>
                  <LoanAmount
                    projectCurrencies={projectCurrencies}
                    format="0,000,000.00"
                    amount={data.totalPrice}
                    prefix={<CurrencySymbol />}
                    precise={false}
                  />
                </h3>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ))
      }
    </Grid>
  );
};
ProjectUnitPackagePricingView.propTypes = {
  projectCurrencies: PropTypes.oneOfType([PropTypes.array]),
  unitPackagePricings: PropTypes.oneOfType([PropTypes.array]).isRequired,
  spaValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  isPreviewing: PropTypes.bool,
  calculatePackagePricing: PropTypes.oneOfType([PropTypes.array]).isRequired,
  sellingPriceCustomName: PropTypes.string,
  t: PropTypes.func,
};

const SortableItem = SortableElement(props => (
  <div className={`sortablehoc_item ${props.itemClass ? props.itemClass : ''}`}>
    <Segment className="package_pricing_unit">
      <Grid>
        <Grid.Row verticalAlign="middle">
          <Grid.Column mobile={2} tablet={2} computer={1}>
            <SortableDragHandle {...props} />
          </Grid.Column>
          <Grid.Column mobile={11} tablet={12} computer={12}>
            <UnitPackagePricingEdit
              {...props}
              data={props.value}
              packagePricings={props.packagePricings}
              onChange={props.onChange}
              refValidation={props.refValidation}
              refForm={props.refForm}
            />
          </Grid.Column>
          <Grid.Column mobile={3} tablet={2} computer={3} textAlign="right" style={{ paddingLeft: '0' }}>
            <Popup
              trigger={
                <Button
                  basic
                  style={{ padding: '0.5em' }}
                >
                  <Icon
                    name="ellipsis horizontal"
                    rotated="clockwise"
                    style={{ margin: '0 auto' }}
                  />
                </Button>
              }
              size="small"
              position="bottom right"
              flowing
              hoverable
              wide
              className="popupUnitInfo"
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Menu fluid vertical className="unitInfoPPpopupButton">
                      <Menu.Item>
                        <small>{props.t('Visible in')}</small>
                      </Menu.Item>
                      <Menu.Item>
                        <span>{props.t('Marketplace')}</span>
                        <Checkbox
                          fitted
                          toggle
                          name="MP"
                          checked={
                            props.value.accessibleIn ?
                              !!props.value.accessibleIn.includes('MP')
                            : false
                          }
                          onClick={(e, data) => props.onVisibilityChange(data, props.value, 'accessibleIn')}
                        />
                      </Menu.Item>
                      <Menu.Item>
                        <span>{props.t('Showroom for buyers')}</span>
                        <Checkbox
                          fitted
                          toggle
                          name="SRB"
                          checked={
                            props.value.accessibleIn ?
                              !!props.value.accessibleIn.includes('SRB')
                            : false
                          }
                          onClick={(e, data) => props.onVisibilityChange(data, props.value, 'accessibleIn')}
                        />
                      </Menu.Item>
                      <Menu.Item className="deleteUnitPackagePricing">
                        <Button
                          size="small"
                          basic
                          onClick={() => props.onDelete(props.value)}
                        >
                          <Icon name="trash" color="red" />
                          <span>{props.t('Delete', { ns: TRANSLATION_FILES.translation })}</span>
                        </Button>
                      </Menu.Item>
                    </Menu>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Popup>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
));

class ProjectUnitPackagePricing extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    calculatePackagePricing: PropTypes.oneOfType([PropTypes.array]).isRequired,
    data: PropTypes.oneOfType([PropTypes.array]).isRequired,
    handleCheckChanges: PropTypes.func,
    handleResetCheck: PropTypes.func,
    hasEditAccess: PropTypes.bool,
    hasGenerateQuotationAccess: PropTypes.bool,
    hasPreviewPriceAccess: PropTypes.bool,
    isBumiUnit: PropTypes.bool,
    loading: PropTypes.bool,
    newFetch: PropTypes.func,
    onToggleQuotationPreview: PropTypes.func,
    packagePricings: PropTypes.oneOfType([PropTypes.array]).isRequired,
    projectCurrencies: PropTypes.oneOfType([PropTypes.array]),
    projectDefaultBFP: PropTypes.number,
    projectDefaultBumiPackagePricingID: PropTypes.string,
    projectDefaultPackagePricingID: PropTypes.string,
    projectID: PropTypes.string,
    projectName: PropTypes.string,
    projectQuatationCode: PropTypes.string,
    showQuotationOpts: PropTypes.bool,
    spaValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    token: PropTypes.string,
    t: PropTypes.func,
    unitID: PropTypes.string,
    unitReference: PropTypes.string,
    isMobile: PropTypes.bool,
  }
  static getPropsToState = (props) => {
    const data = props.data || [];
    const loading = props.loading;
    const packagePricings = props.packagePricings || [];
    const calculatePackagePricing = props.calculatePackagePricing || [];
    const token = props.token || '';
    const showQuotationOpts = props.showQuotationOpts || false;

    let globalSettings = {};
    const storeGloablSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    return {
      data,
      oriData: clone(data),
      loading,
      packagePricings,
      calculatePackagePricing,
      token,
      globalSettings,
      showQuotationOpts,
    };
  }
  constructor(props) {
    super(props);
    const state = ProjectUnitPackagePricing.getPropsToState(props);
    this.state = {
      ...state,
      editing: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
      showPreview: false,
    };
    this.editRef = [];
    this.formRef = {};
  }
  componentWillReceiveProps(nextProps) {
    const state = ProjectUnitPackagePricing.getPropsToState(nextProps);
    if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
      this.setState({ ...state });
    }
    if (JSON.stringify(this.state.calculatePackagePricing) !== JSON.stringify(state.calculatePackagePricing)) {
      this.setState({
        calculatePackagePricing: state.calculatePackagePricing,
      });
    }
    if (this.state.showQuotationOpts !== state.showQuotationOpts) {
      this.setState({ showQuotationOpts: state.showQuotationOpts });
    }
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const data = this.sortDataByIndex(arrayMove(this.state.data, oldIndex, newIndex));
    this.setState({ data }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  };
  onVisibilityChange = (d, pp, nameField, idx) => {
    const name = d.name;
    const newData = pp.accessibleIn ? pp.accessibleIn : [];
    const { data } = this.state;

    if (name === 'SRB') {
      const isAccessible = newData ? newData.includes('SRB') : false;
      if (isAccessible === true) {
        const index = newData.indexOf('SRB');
        newData.splice(index, 1);
      } else if (isAccessible === false) {
        newData.push(name);
        data[idx][nameField] = newData;
      }
    } else if (name === 'MP') {
      const isAccessible = newData ? newData.includes('MP') : false;
      if (isAccessible === true) {
        const index = newData.indexOf('MP');
        newData.splice(index, 1);
      } else if (isAccessible === false) {
        newData.push(name);
        data[idx][nameField] = newData;
      }
    }
    this.setState({ data });
  }
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  getPackagePricings = () => {
    const { data } = this.state;
    // filter out already added package pricings
    const packagePricings = this.state.packagePricings.filter(p => !data.find(d => d.id !== '' && d.projectPackagePricingID === p.id)).sort((a, b) => a.orderPriority - b.orderPriority);
    const options = [];
    packagePricings.forEach((p) => {
      const newItem = {
        text: p.name,
        value: p.id,
      };
      // disabled the option once selected
      const selectedItem = data.find(d => d.projectPackagePricingID === p.id);
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  }
  setRefValidation = (ref, idx) => {
    if (ref && ref.props && ref.props.name) {
      if (!this.editRef[idx]) this.editRef[idx] = {};
      this.editRef[idx][ref.props.name] = ref;
    }
  }
  setRefForm = (ref) => {
    this.formRef = ref;
  }
  sortDataByIndex = (newData) => {
    const data = newData;
    data.forEach((d, index) => {
      data[index].orderPriority = index + 1;
    });
    return data;
  }
  async deleteUnitPackagePricing(id, callBack) {
    await this.setLoading(true);
    const { store } = this.context;
    const { projectID, unitID, t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/package_pricings/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({
        header: t('Delete Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Unit pricing package successfully deleted', { ns: TRANSLATION_FILES.translation }),
      }));
    }
    await this.setLoading(false);
    if (callBack) callBack();
  }
  async updateUnitPackagePricings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { projectID, unitID, t } = this.props;
    const data = this.state.data.filter((d) => {
      const newD = d;
      newD.totalPrice = parseFloat(d.totalPrice);
      return newD;
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/package_pricings/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      if (this.props.newFetch) await this.props.newFetch();
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Unit pricing package successfully updated', { ns: TRANSLATION_FILES.translation }),
      }));
      if (this.props.handleResetCheck) this.props.handleResetCheck();
    }
    await this.setLoading(false);
  }
  asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index += 1) {
      await callback(array[index], index, array);
    }
  }
  handleEditing = () => {
    this.setState({ editing: true });
  }
  handleResetEditing = () => {
    if (this.props.handleResetCheck) this.props.handleResetCheck();
    this.setState({
      editing: false,
    }, async () => {
      if (JSON.stringify(this.state.data) !== JSON.stringify(this.props.data)) {
        if (this.props.newFetch) await this.props.newFetch();
      }
    });
  }
  handleUpdate = async () => {
    if (JSON.stringify(this.state.data) === JSON.stringify(this.state.oriData)) {
      await this.setComponentState({ editing: false });
      return;
    }
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    let hasError = false;
    await this.asyncForEach(data, async (d, idx) => {
      if (this.editRef[idx] && !hasError) {
        const validations = await AppForm.validate(this.editRef[idx], data[idx]);
        const errMessages = validations.filter(v => !v.isValid);
        if (errMessages.length > 0) {
          hasError = true;
          await store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
        }
      }
    });
    if (!hasError) {
      await this.updateUnitPackagePricings();
      await this.setComponentState({ editing: false });
    }
  }
  handleOnChange = (d, idx) => {
    const { data } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    this.setState({ data: newData }, () => {
      if (this.editRef[idx]) AppForm.validate(this.editRef[idx], newData[idx]);
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleDelete = (d, idx) => {
    this.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
    });
  }
  handleConfirmDelete = async (e) => {
    e.preventDefault();
    const { deleteData } = this.state;
    if (deleteData.id !== '') {
      await this.deleteUnitPackagePricing(deleteData.id, () => {
        this.confirmDelete();
      });
    } else {
      this.confirmDelete();
    }
  }
  confirmDelete = () => {
    const { data, deleteIDX } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    this.setState({
      data: this.sortDataByIndex(newData),
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
      deleteIDX: null,
      showDeleteConfirm: false,
    }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleAdd = (e) => {
    e.preventDefault();
    const { data } = this.state;
    const { projectID, unitID } = this.props;
    const newItem = clone(Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1,
      projectID,
      projectUnitID: unitID,
      accessibleIn: ['MP', 'SRB'],
    }));
    data.push(newItem);
    this.setState({ data }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleTogglePreview = (e, data) => {
    e.preventDefault();
    const { name } = data;
    this.setState(prevState => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  }
  render() {
    const {
      calculatePackagePricing,
      data,
      globalSettings,
      loading,
      showDeleteConfirm,
      showPreview,
    } = this.state;
    const {
      hasEditAccess,
      hasGenerateQuotationAccess,
      hasPreviewPriceAccess,
      isBumiUnit,
      newFetch,
      onToggleQuotationPreview,
      projectCurrencies,
      projectDefaultBFP,
      projectDefaultBumiPackagePricingID,
      projectDefaultPackagePricingID,
      projectID,
      projectName,
      projectQuatationCode,
      showQuotationOpts,
      spaValue,
      t,
      unitID,
      unitReference,
      isMobile,
    } = this.props;
    return (
      <div>
        <DeleteConfirm
          content={`${t('Are you sure you want to delete this unit pricing package')}?`}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          open={showDeleteConfirm}
        />
        <EditableBox
          editable={hasEditAccess}
          isEditing={this.state.editing}
          loading={loading}
          onCancel={this.handleResetEditing}
          onClick={this.handleUpdate}
          onEdit={this.handleEditing}
          showPreview={showPreview || showQuotationOpts}
          content={({ isEditing }) => (
            <div>
              <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'flex-start' }}>
                {
                  hasPreviewPriceAccess && !showQuotationOpts &&
                  <Button
                    as="button"
                    attached="top"
                    style={{
                      background: showPreview ? '#eae8e8' : 'none',
                      width: isMobile ? '63%' : '29%',
                      top: hasEditAccess && !showPreview ? '-2.5em' : '0',
                      borderRadius: '0.2em',
                      paddingRight: '1.5em',
                      display: isEditing ? 'none' : 'inline-block',
                      marginBottom: !hasEditAccess || showPreview ? '1.5em' : '0',
                      marginLeft: isMobile ? '0' : '1em',
                      ...(isMobile && { marginBottom: '0.8em' }),
                    }}
                    content={t(showPreview ? 'Close' : 'Preview Price Breakdown', { ns: TRANSLATION_FILES.translation })}
                    icon={showPreview ? 'close' : 'eye'}
                    size="tiny"
                    name="showPreview"
                    onClick={this.handleTogglePreview}
                  />
                }
                {
                  hasGenerateQuotationAccess && !showPreview && !showQuotationOpts &&
                  <Button
                    as="button"
                    attached="top"
                    style={{
                      background: 'none',
                      width: isMobile ? '63%' : '29%',
                      top: hasEditAccess ? '-2.5em' : '0',
                      borderRadius: '0.2em',
                      paddingRight: '1.5em',
                      display: isEditing ? 'none' : 'inline-block',
                      marginBottom: hasEditAccess ? '0' : '1.5em',
                      marginLeft: isMobile ? '0' : '1em',
                    }}
                    content={t('Generate Quotation')}
                    icon={'print'}
                    size="tiny"
                    name="showQuotationOpts"
                    onClick={() => onToggleQuotationPreview(true)}
                  />
                }
              </div>
              {
                isEditing ?
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {data.length > 0 ? (
                          <SortableContainer
                            isSortMode
                            iconColor="blue"
                            helperClass="sorting"
                            data={data}
                            lockAxis="y"
                            lockToContainerEdges
                            onSortEnd={this.onSortEnd}
                            useDragHandle
                            item={props => (
                              <SortableItem
                                {...props}
                                onChange={d => this.handleOnChange(d, props.idx)}
                                onVisibilityChange={e => this.onVisibilityChange(e, props.value, 'accessibleIn', props.idx)}
                                onDelete={d => this.handleDelete(d, props.idx)}
                                refForm={this.setRefForm}
                                refValidation={ref => this.setRefValidation(ref, props.idx)}
                                packagePricings={this.getPackagePricings}
                                t={t}
                              />
                            )}
                          />
                        ) : (
                          <Segment className="segment_unit_pricing_package_not_found" textAlign="center">{t('No unit pricing package found')}</Segment>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row textAlign="center">
                      <Grid.Column width={16}>
                        <Button
                          basic
                          onClick={this.handleAdd}
                        >
                          <Icon name="add circle" color="green" /> {t('Add pricing package')}
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  :
                  <div>
                    {
                      !showQuotationOpts && (
                        <ProjectUnitPackagePricingView
                          unitPackagePricings={data}
                          projectCurrencies={projectCurrencies}
                          spaValue={spaValue}
                          isPreviewing={showPreview && !showQuotationOpts}
                          calculatePackagePricing={calculatePackagePricing}
                          sellingPriceCustomName={globalSettings && globalSettings.sellingPrice}
                          t={t}
                        />
                      )
                    }
                    <QuotationPackageSelection
                      calculatePackagePricing={calculatePackagePricing}
                      isBumiUnit={isBumiUnit}
                      isPreviewing={showQuotationOpts}
                      newFetch={newFetch}
                      onTogglePreview={onToggleQuotationPreview}
                      projectDefaultBookingFeeAmount={projectDefaultBFP}
                      projectDefaultBumiPackagePricingID={projectDefaultBumiPackagePricingID}
                      projectDefaultPackagePricingID={projectDefaultPackagePricingID}
                      projectID={projectID}
                      projectName={projectName}
                      projectQuatationCode={projectQuatationCode}
                      sellingPriceCustomName={globalSettings && globalSettings.sellingPrice}
                      spaValue={spaValue}
                      t={t}
                      token={this.state.token}
                      unitID={unitID}
                      unitPackagePricings={data}
                      unitReference={unitReference}
                    />
                  </div>
              }
            </div>
          )}
        />
      </div>
    );
  }
}

export default withTranslation(namespaces)(ProjectUnitPackagePricing);



// WEBPACK FOOTER //
// ./src/components/ProjectUnitPackagePricing/ProjectUnitPackagePricing.jsx